var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.986 2.75H3.964c-.67 0-1.214.531-1.214 1.186v14.08c0 .656.544 1.188 1.214 1.188h14.022c.671 0 1.218-.532 1.218-1.187V3.936c0-.655-.547-1.186-1.218-1.186zM5.19 16.771H7.63V8.92H5.19v7.852zM6.41 5.015a1.415 1.415 0 11-.002 2.831 1.415 1.415 0 01.002-2.83zM9.16 8.92h2.342v1.073h.032c.326-.618 1.122-1.269 2.31-1.269 2.47 0 2.927 1.627 2.927 3.741v4.307h-2.439v-3.818c0-.912-.017-2.083-1.268-2.083-1.27 0-1.465.992-1.465 2.017v3.884H9.161V8.92z",
    fill: "#fff"
  })));
}
export default SvgLinkedin;